import Ajax from "./Ajax"
const GetAmenity = async() => {
    const response = await Ajax({
        url: `/amenities?limit=false`,
        token: true
    })
    return response.data.result
}
export default GetAmenity